import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M11 15h2v-2h-2v2zM21 3H3v18h18V3zm-6 6h-4v2h4v6H9V7h6v2z"
}), 'Looks6Sharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Looks6Sharp.js
// module id = 4725
// module chunks = 2